import React from "react";
import PricingSection from "./sections/PricingSection";

const AdvanceScreen = () => {
  return <PricingSection />;
};

export default AdvanceScreen;
